// @flow

import * as React from 'react';
import { Pressable, View } from 'react-native';
import { pageStyles } from 'src/navigation/defaultPageStyles';
import Text from 'src/components/CustomText/CustomText';
import { FormattedMessage } from 'react-intl';
import styles from 'src/navigation/Profile/ProfileStyles';
import { Icon } from 'react-native-elements';
import { LIGHT_GREY_COLOR, PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';
import ServiceIcon from 'src/Icons/ServiceIcon';
import ServiceDisabledIcon from 'src/Icons/ServiceDisabledIcon';
import { APIContext } from 'speed-js-react';

type Props = {
    width: any,
    accountUUUD: string,
    profileUuid: string | undefined,
    setProfileDevices: Function,
    setHasChange: Function,
    profileDevices: Array<Object>,
}

const ProfileDevices = (props: Props) => {
    const {
        width, profileDevices, setProfileDevices, setHasChange, accountUUUD, profileUuid,
    } = props;

    const { apiClient } = React.useContext(APIContext);

    const [devices, setDevices] = React.useState(null);

    const getDevices = React.useCallback(() => {
        if (accountUUUD) {
            apiClient.resources.devices.list({ account_id: accountUUUD })
                .then((res) => {
                    setDevices(res.results);
                    if (profileUuid) {
                        const dp = res.results.filter((device) => device.profiles.includes(profileUuid))
                            .map((d) => d.uuid);
                        setProfileDevices(dp);
                    } else {
                        setProfileDevices(res.results.map((d) => d.uuid));
                    }
                });
        }
    }, [accountUUUD, apiClient.resources.devices, profileUuid, setProfileDevices]);

    React.useEffect(() => {
        getDevices();
    }, [getDevices]);

    return (
        <>
            <View style={pageStyles.added}>
                <View style={width > 600 ? pageStyles.channels_label : pageStyles.channels_label_phone}>
                    <Text style={width > 600 ? pageStyles.available_channels_label
                        : pageStyles.available_channels_label_phone}
                    >
                        <FormattedMessage
                            id="added-in-devices"
                            defaultMessage="The profile is added in devices"
                        />
                    </Text>
                    <View style={styles.device_buttons_wrapper}>
                        <Pressable
                            onPress={() => {
                                if (devices) {
                                    setProfileDevices(devices.map((device) => device.uuid));
                                    setHasChange(true);
                                }
                            }}
                            style={pageStyles.centered}
                        >
                            <Text style={[width > 600 ? pageStyles.light_blue
                                : [pageStyles.light_blue, pageStyles.centered],
                            width < 600 && pageStyles.up_button]}
                            >
                                <FormattedMessage
                                    id="add-all"
                                    defaultMessage="Add All"
                                />
                            </Text>
                        </Pressable>
                        <Pressable
                            onPress={() => {
                                setProfileDevices([]);
                                setHasChange(true);
                            }}
                            style={pageStyles.centered}
                        >
                            <Text style={[width > 600 ? pageStyles.light_blue
                                : [pageStyles.light_blue, pageStyles.centered],
                            width < 600 && pageStyles.up_button]}
                            >
                                <FormattedMessage
                                    id="remove-all"
                                    defaultMessage="Remove All"
                                />
                            </Text>
                        </Pressable>
                    </View>
                </View>
            </View>
            <View style={width > 600 ? styles.device_wrapper : styles.device_wrapper_phone}>
                {devices && devices.map((device) => (
                    <View
                        style={width > 600 ? styles.device_box : styles.device_box_phone}
                        key={device.uuid}
                    >
                        <Pressable
                            onPress={() => {
                                if (profileDevices.includes(device.uuid)) {
                                    setProfileDevices(profileDevices
                                        .filter((profileDevice) => profileDevice !== device.uuid));
                                } else {
                                    setProfileDevices([...profileDevices, device.uuid]);
                                }
                                setHasChange(true);
                            }}
                        >
                            <View style={width > 600 ? styles.device_container : styles.device_container_phone}>
                                {profileDevices.includes(device.uuid)
                                    ? (
                                        <View style={styles.device_icon_container}>
                                            <Icon
                                                color={PRIMARY_COLOR}
                                                type="ionicon"
                                                name="checkbox-outline"
                                                containerStyle={styles.checkbox}
                                                size={width > 600 ? 30 : 20}
                                            />
                                            <ServiceIcon
                                                width={width < 600 ? 80 : 120}
                                            />
                                        </View>
                                    ) : (
                                        <View style={styles.device_icon_container}>
                                            <Icon
                                                color={LIGHT_GREY_COLOR}
                                                type="ionicon"
                                                name="square-outline"
                                                containerStyle={styles.checkbox}
                                                size={width > 600 ? 30 : 20}
                                            />
                                            <ServiceDisabledIcon
                                                width={width < 600 ? 80 : 120}
                                            />
                                        </View>
                                    )}
                            </View>
                        </Pressable>
                        <Text style={width > 600 ? styles.device_text : styles.device_text_phone}>
                            {device.name}
                        </Text>
                    </View>
                ))}
            </View>
        </>
    );
};

export default ProfileDevices;
